'use client'

import { Loader, Spacer, Text } from '@vinted/web-ui'
import { useCallback, useState } from 'react'
import { useInterval } from 'usehooks-ts'

import {
  WalletConversionStatus,
  getWalletConversionStatus,
} from '@marketplace-web/business-accounts/business-accounts-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  onStatusChange: (status: WalletConversionStatus) => void
}

const MIN_POLLING_DELAY_MS = 500
const MAX_POLLING_DELAY_MS = 30000

const PendingState = ({ onStatusChange }: Props) => {
  const translate = useTranslate('business.wallet.status.pending')
  const [pollingDelay, setPollingDelay] = useState(MIN_POLLING_DELAY_MS)

  const fetchConversionStatus = useCallback(async () => {
    const response = await getWalletConversionStatus()

    if ('errors' in response || !response.state) return

    onStatusChange(response.state)
  }, [onStatusChange])

  useInterval(() => {
    fetchConversionStatus()
    setPollingDelay(delay => Math.min(delay * 2, MAX_POLLING_DELAY_MS))
  }, pollingDelay)

  return (
    <div className="u-flexbox u-flex-direction-column u-align-items-center">
      <Loader size="x-large" />
      <Spacer size="x2-large" />
      <Text as="h1" type="heading" alignment="center" text={translate('title')} />
      <Spacer />
      <Text as="span" alignment="center" html text={translate('body')} />
    </div>
  )
}

export default PendingState
